import { ResponseHeader } from "./ResponseHeader"

/**
 * Gets Content-Type from response, excluding charset.
 *
 * Extracts MIME type from Content-Type header, removing parameters.
 *
 * @param r - Request, Response, or XMLHttpRequest object
 * @param cttp - Default content type (default: "application/octet-stream")
 * @returns MIME type in lowercase
 *
 * @example
 * ```ts
 * import { ResponseContentType } from "@pdfking/tfunc"
 *
 * const mimeType = ResponseContentType(response)
 * // "application/json" from "application/json; charset=utf-8"
 * ```
 */
export const ResponseContentType = (
  r: Request | Response | XMLHttpRequest,
  cttp: string = "application/octet-stream"
): string => ResponseHeader(r, "content-type", cttp).split(";")[0].toLowerCase()
